module.exports = "<div class=\"row-wrapper\"\n     [class.with-bold-title]=\"boldTitle\">\n    <div class=\"title-wrapper\">\n        <div *ngIf=\"title\" class=\"title\" [innerHTML]=\"title | translate | highlight:highlightPhrase:3\"></div>\n        <div [class.control-wrapper]=\"true\" [class.flex]=\"controlFlex\">\n            <ng-content></ng-content>\n        </div>\n    </div>\n    <div *ngIf=\"description\"\n         class=\"description\" [innerHTML]=\"description | translate | highlight:highlightPhrase:3\"></div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-form-element/ui-form-element.html
// module id = 1102
// module chunks = 3